import { isUndefined } from './../utils';
import { Ticker } from './../utils/ticker';
import { PositionAdapter } from './PositionAdapter';
export class LayoutUndoUnit {
    constructor(initialState, finalState, animate) {
        if (isUndefined(animate)) {
            this.animate = false;
        }
        else {
            this.animate = Boolean(animate);
        }
        this._initialState = initialState;
        this._finalState = finalState;
        this.title = 'Diagram layout';
    }
    undo() {
        this.setState(this._initialState);
    }
    redo() {
        this.setState(this._finalState);
    }
    setState(state) {
        const diagram = state.diagram;
        if (this.animate) {
            state.linkMap.forEach(function (id, points) {
                const conn = diagram.getShapeById(id);
                conn.visible(false);
                if (conn) {
                    conn.points(points);
                }
            });
            const ticker = new Ticker();
            ticker.addAdapter(new PositionAdapter(state));
            ticker.onComplete(function () {
                state.linkMap.forEach(function (id) {
                    const conn = diagram.getShapeById(id);
                    conn.visible(true);
                });
            });
            ticker.play();
        }
        else {
            state.nodeMap.forEach(function (id, bounds) {
                const shape = diagram.getShapeById(id);
                if (shape) {
                    shape.position(bounds.topLeft());
                }
            });
            state.linkMap.forEach(function (id, points) {
                const conn = diagram.getShapeById(id);
                if (conn) {
                    conn.points(points);
                }
            });
        }
    }
}
